import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  addToCompare,
  getInstitutionsInCompare,
  removeFromCompare,
  sendEmail
} from './compare.actions';
import { selectInstitutions, selectInstitutionsInCompare } from './compare.selectors';
import { Observable } from 'rxjs';
import { Institution } from 'src/generated/graphql';
import { InstitutionInCompare } from '../../models/institution-in-compare';

@Injectable({
  providedIn: 'root'
})
export class CompareFacadeService {
  public get institutions$(): Observable<(Institution | null)[]> {
    return this.store.select(selectInstitutions);
  }

  public get institutionsInCompare$(): Observable<InstitutionInCompare[]> {
    return this.store.select(selectInstitutionsInCompare);
  }

  constructor(private store: Store) {}

  public addToCompare(institution: Institution): void {
    this.store.dispatch(addToCompare({ institution }));
  }

  public removeFromCompare(institution: Institution): void {
    this.store.dispatch(removeFromCompare({ institution }));
  }

  public sendEmail(body: FormData): void {
    this.store.dispatch(sendEmail({ body }));
  }

  public getInstitutionsInCompare(): void {
    this.store.dispatch(getInstitutionsInCompare());
  }
}
